





































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import XitiFilter from "../components/xiti-filter.vue";
import XitiSelect from "../components/xiti-select.vue";
import {
  GetRandomQuestionTem,
  EditPaper,
  GetPaperDetail,
  DelPaperQuestions,
  GetPaperQuestions,
  EditScore,
} from "@/request/common";
@Component({
  components: {
    Header,
    LeftNav,
    XitiFilter,
    XitiSelect,
  },
})
export default class Name extends mixins(listMixin) {
  private id: any = "";
  private ifShowFilter: any = false;
  private ifShowSelect: any = false;
  private detail: any = {};
  private data: any = [];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private goPreview() {
    this.$router.push({
      path: "/main/teacher/exam-paper-preview",
      query: {
        id: this.detail.paper_id,
      },
    });
  }
  private editScore(item: any) {
    item.edit = true;
    this.$forceUpdate();
  }
  private startSelect(type: any) {
    if (!this.detail["名称"]) {
      this.$message.warning("请输入试卷名称");
      return;
    }
    if (type == "随机") {
      this.ifShowFilter = true;
    } else if (type == "手动") {
      this.ifShowSelect = true;
    }
  }
  private filterChange(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetRandomQuestionTem(this, e, loading)
      .then((d: any) => {
        const params: any = {
          paper_id: this.detail.paper_id,
          名称: this.detail["名称"],
          questions: d,
          action: "随机",
        };
        EditPaper(this, params)
          .then((res: any) => {
            loading.close();
            this.$message.success(
              `${this.detail.paper_id ? "编辑" : "新建"}成功`
            );
            this.ifShowFilter = false;
            this.ifShowSelect = false;
            this.detail.paper_id = res;
            this.getList();
            this.getDetail();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch(() => {
        loading.close();
      });
  }
  private xitiSelect(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      paper_id: this.detail.paper_id,
      名称: this.detail["名称"],
      questions: e,
      action: "手动",
    };
    EditPaper(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(`${this.detail.paper_id ? "编辑" : "新建"}成功`);
        this.ifShowFilter = false;
        this.ifShowSelect = false;
        this.detail.paper_id = res;
        this.getList();
        this.getDetail();
      })
      .catch(() => {
        loading.close();
      });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            paper_id: this.detail.paper_id,
            question_ids: [item.question_template_id],
          },
        };
        DelPaperQuestions(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
            this.getDetail();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private delAll() {
    if (this.selectedMessages.length == 0) {
      this.$message.warning("请选择需要删除的数据");
      return;
    }
    this.$confirm("您确定要删除所选数据么？", "批量删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      let ids: any = [];
      this.selectedMessages.forEach((ele: any) => {
        ids.push(ele.question_template_id);
      });
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          paper_id: this.detail.paper_id,
          question_ids: ids,
        },
      };
      DelPaperQuestions(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("批量删除成功");
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
          this.getDetail();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private blur(item: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      paper_id: this.detail.paper_id,
      question_template_id: item.question_template_id,
      score: item.score,
    };
    EditScore(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("修改成功");
        this.getDetail();
      })
      .catch(() => {
        loading.close();
      });
  }
  getList() {
    if (!this.detail.paper_id) {
      this.ifShowEmpty = true;
      return;
    }
    const params = {
      paper_id: this.detail.paper_id,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("editPaperFilter", JSON.stringify(this.filters));
    GetPaperQuestions(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((element: any) => {
          element["edit"] = false;
          const inc = this.selectedMessages.findIndex((i: any) => {
            return (
              i["question_template_id"] === element["question_template_id"]
            );
          });
          if (inc !== -1) {
            element["selected"] = true;
          } else {
            element["selected"] = false;
          }
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  private getDetail() {
    if (!this.detail.paper_id) {
      return;
    }
    const params: any = {
      params: {
        paper_id: this.detail.paper_id,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetPaperDetail(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.detail = res;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (localStorage.getItem("editPaperFilter")) {
      this.filters = JSON.parse(localStorage.getItem("editPaperFilter") as any);
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.detail.paper_id = this.$route.query.id;
      this.getDetail();
    }
  }
}
